import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TagList from './components/tagList';
import logger from 'src/analytics/logger';

const MediaTagFilter = ({
  tags,
  allTag = 'All Topics',
  mediaElementClass,
  containerIds = [],
  mediaChangedEvent = 'mediaChanged',
  tagDataAttribute = 'tags'
}) => {
  const [activeTag, setActiveTag] = useState(allTag);

  const allTags = () => [allTag].concat(tags);

  const dispatchMediaChangeEvent = () => {
    containerIds.forEach((containerId) => {
      let container = document.getElementById(containerId);
      container.dispatchEvent(new Event(mediaChangedEvent));
    });
  };

  const showOnlyWithTag = (tag) => {
    containerIds.forEach((containerId) => {
      let container = document.getElementById(containerId);
      container.querySelectorAll(`.${mediaElementClass}`).forEach((element) => {
        let elementTags =
          element.dataset[tagDataAttribute.toLowerCase()]?.split(',') || [];
        element.style.display = elementTags.includes(tag) ? 'block' : 'none';
      });
    });
  };

  const showAllMedia = () => {
    containerIds.forEach((containerId) => {
      let container = document.getElementById(containerId);
      container.querySelectorAll(`.${mediaElementClass}`).forEach((element) => {
        element.style.display = 'block';
      });
    });
  };

  const logTagChange = (tag) => {
    logger.trackElementClicked({
      elementId: 'Content Search',
      label: tag,
      path: '/learn/explore'
    });
  };

  const setTagInUrl = (tag) => {
    if (tag !== allTag) {
      history.pushState(null, null, `explore#tag=${tag}`);
    }
    if (tag === allTag) {
      history.pushState(null, null, 'explore');
    }
  };

  const validateTag = (tag) => (allTags().includes(tag) ? tag : allTag);

  const handleTagChange = (tag) => {
    let newTag = validateTag(tag);
    logTagChange(newTag);
    setTagInUrl(newTag);
    setActiveTag(newTag);
  };

  const applyTagFromUrl = () => {
    let tag = new URLSearchParams(window.location.hash.substring(1)).get('tag');
    if (tag) {
      setActiveTag(validateTag(tag));
    }
  };

  useEffect(applyTagFromUrl, []); // Only run on initial render

  useEffect(() => {
    if (activeTag === allTag) {
      showAllMedia();
    } else {
      showOnlyWithTag(activeTag);
    }
    dispatchMediaChangeEvent();
  }, [
    activeTag,
    allTag,
    showAllMedia,
    showOnlyWithTag,
    dispatchMediaChangeEvent
  ]);

  const optionTags = () =>
    allTags().map((tag) => (
      <option key={tag} value={tag}>
        {tag}
      </option>
    ));

  return (
    <>
      <div className="sm:block hidden" data-testid="tagList">
        <TagList
          tags={allTags()}
          activeTag={activeTag}
          onTagSelected={handleTagChange}
        />
      </div>
      <div className="gzl-Select sm:hidden w-full">
        <select
          className="w-full"
          title="tags"
          value={activeTag}
          data-testid="dropdown"
          onChange={(event) => handleTagChange(event.target.value)}
        >
          {optionTags()}
        </select>
      </div>
    </>
  );
};

MediaTagFilter.propTypes = {
  tags: PropTypes.array,
  allTag: PropTypes.string,
  containerIds: PropTypes.array,
  mediaChangedEvent: PropTypes.string,
  mediaElementClass: PropTypes.string,
  tagDataAttribute: PropTypes.string
};

export default MediaTagFilter;
